<template>
  <div>
    <salidasList />
  </div>
</template>

<script>

const salidasList = () => import('@/layouts/components/Salidas/SalidasList.vue')

export default {
  components: {
    salidasList,
  },
}
</script>

<style>

</style>
